var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1171.101,
    height: 67,
    viewBox: "0 0 1171.101 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2852",
    x: 0,
    y: 5,
    width: 1171.101,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#042944",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_9974"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#61a2f5",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12436"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#61a2f5",
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12436-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#61a2f5",
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12436-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#61a2f5",
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12436-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#61a2f5",
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_12434"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#61a2f5",
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "progress-bar",
    transform: "translate(2878 -2743.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108",
    transform: "translate(-12 19.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2866, 2724)",
    filter: "url(#Rectangle_2852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2852-2",
    "data-name": "Rectangle 2852",
    width: 1159.101,
    height: 50,
    rx: 10,
    transform: "translate(6 7)",
    fill: "#373f45"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 1159.101,
    height: 50,
    rx: 10,
    transform: "translate(-2860 2724)",
    fill: "#4c5c69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107",
    transform: "translate(-13 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_6_Byg",
    "data-name": "6 Byg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-fill-6",
    transform: "translate(972.351 -0.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    d: "M0,0H182.14a10,10,0,0,1,10,10V47a10,10,0,0,1-10,10H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(-2863.389 2725)",
    fill: "#0f4b98"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9974-2",
    "data-name": "Path 9974",
    d: "M13.955,0H193.408a14.123,14.123,0,0,1,5.874.722A10.283,10.283,0,0,1,203.395,3.8a10.3,10.3,0,0,1,1.7,3.267,9,9,0,0,1,.449,2.614v33.6s-.622,3.314-2.735,4.994S197.091,50,197.091,50H13.955A9.978,9.978,0,0,1,4,40V10A9.978,9.978,0,0,1,13.955,0Z",
    transform: "translate(-2876.792 2725)",
    fill: "#2c71cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3837.35, 2724.95)",
    filter: "url(#Path_9974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9974-3",
    "data-name": "Path 9974",
    d: "M13.955,0H193.408a14.123,14.123,0,0,1,5.874.722A10.283,10.283,0,0,1,203.395,3.8a10.3,10.3,0,0,1,1.7,3.267,9,9,0,0,1,.449,2.614v33.6s-.622,3.314-2.735,4.994S197.091,50,197.091,50H13.955A9.978,9.978,0,0,1,4,40V10A9.978,9.978,0,0,1,13.955,0Z",
    transform: "translate(960.56 0.05)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "text-6",
    d: "M60.958,13.59v-.126c0-2.988-2.016-4.014-4.446-4.014a12.7,12.7,0,0,0-2.124.216V9.54c0-2,.666-2.628,2.25-2.628a22.655,22.655,0,0,1,3.276.252H60c.2,0,.324-.126.324-.378V5.22c0-.216-.108-.324-.4-.4a15.328,15.328,0,0,0-3.546-.36c-3.06,0-5,1.584-5,5.652V12.87c0,3.582,1.926,5.292,4.824,5.292C59.3,18.162,60.958,16.326,60.958,13.59Zm-3.006,0c0,1.764-.756,2.232-1.746,2.232-1.044,0-1.818-.5-1.818-2.952v-1.1a11.694,11.694,0,0,1,1.638-.18c1.062,0,1.926.4,1.926,1.872Zm19.908.54v-.27a2.872,2.872,0,0,0-1.6-2.664A2.849,2.849,0,0,0,77.77,8.55V8.226c0-2.862-2.286-3.762-5.688-3.762a27.841,27.841,0,0,0-3.222.2c-.7.108-.954.36-.954,1.17V16.776c0,.81.27,1.044.99,1.17a22.818,22.818,0,0,0,3.294.216C75.3,18.162,77.86,17.3,77.86,14.13ZM74.8,8.694c0,.774-.414,1.422-1.836,1.422H70.948V7c.252-.018,1.08-.018,1.368-.018,1.854,0,2.484.45,2.484,1.44Zm.072,5.364c0,1.008-.594,1.584-2.448,1.584-.252,0-1.188-.018-1.476-.018V12.258h2.016c1.44,0,1.908.738,1.908,1.6ZM89.236,4.9a.27.27,0,0,0-.288-.27H86.356a.4.4,0,0,0-.36.306l-1.944,5.076c-.09.234-.144.27-.27.27s-.18-.036-.27-.27L81.568,4.932a.4.4,0,0,0-.36-.306H78.616a.27.27,0,0,0-.288.27.306.306,0,0,0,.018.126l2.718,6.228a2.349,2.349,0,0,0,1.188,1.386v5a.361.361,0,0,0,.36.36H84.97a.361.361,0,0,0,.36-.36v-5A2.333,2.333,0,0,0,86.5,11.25l2.718-6.228A.306.306,0,0,0,89.236,4.9Zm9.918,2.16V5.148c0-.162-.126-.234-.306-.27a17.059,17.059,0,0,0-3.762-.414c-2.61,0-5.472,1.152-5.472,5.742v2.232c0,4.554,3.078,5.724,5.13,5.724a19.531,19.531,0,0,0,4.032-.378c.27-.054.36-.162.36-.414V11.322a.361.361,0,0,0-.36-.36h-2.3a.346.346,0,0,0-.342.36v4.14c-.432.036-.882.054-1.386.054-.882,0-2.016-.576-2.016-3.06v-2.25c0-2.358.9-3.06,2.358-3.06,1.53,0,2.88.108,3.744.144h.054C99.046,7.29,99.154,7.254,99.154,7.056Z",
    transform: "translate(-1855 2740)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5_Byd",
    "data-name": "5 Byd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-fill-5",
    transform: "translate(778.351 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6386",
    "data-name": "Rectangle 6386",
    width: 194.126,
    height: 57,
    transform: "translate(-2865.351 2725)",
    fill: "#0f4b98"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-5",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-3653.937 2096.287)",
    fill: "#2c71cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3643.35, 2725)",
    filter: "url(#Path_12436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-6",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-10.59 -628.71)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "text-5",
    d: "M59.761,13.752v-.144c0-3.132-2.25-4.014-5.364-4.014h-.522l.216-2.484h4.9a.346.346,0,0,0,.36-.342v-1.8a.346.346,0,0,0-.36-.342h-7a.385.385,0,0,0-.36.342l-.558,6.714V11.7a.257.257,0,0,0,.252.252h2.79c2,0,2.556.45,2.556,1.656v.144c0,1.242-.36,1.962-2.07,1.962-.666,0-2.106-.09-3.24-.216h-.036a.312.312,0,0,0-.324.324v1.422c0,.252.18.342.36.4a12.8,12.8,0,0,0,3.546.522C58.051,18.162,59.761,16.6,59.761,13.752Zm17.316.378v-.27a2.872,2.872,0,0,0-1.6-2.664A2.849,2.849,0,0,0,76.987,8.55V8.226c0-2.862-2.286-3.762-5.688-3.762a27.841,27.841,0,0,0-3.222.2c-.7.108-.954.36-.954,1.17V16.776c0,.81.27,1.044.99,1.17a22.818,22.818,0,0,0,3.294.216C74.521,18.162,77.077,17.3,77.077,14.13Zm-3.06-5.436c0,.774-.414,1.422-1.836,1.422H70.165V7c.252-.018,1.08-.018,1.368-.018,1.854,0,2.484.45,2.484,1.44Zm.072,5.364c0,1.008-.594,1.584-2.448,1.584-.252,0-1.188-.018-1.476-.018V12.258h2.016c1.44,0,1.908.738,1.908,1.6ZM88.453,4.9a.27.27,0,0,0-.288-.27H85.573a.4.4,0,0,0-.36.306l-1.944,5.076c-.09.234-.144.27-.27.27s-.18-.036-.27-.27L80.785,4.932a.4.4,0,0,0-.36-.306H77.833a.27.27,0,0,0-.288.27.306.306,0,0,0,.018.126l2.718,6.228a2.349,2.349,0,0,0,1.188,1.386v5a.361.361,0,0,0,.36.36h2.358a.361.361,0,0,0,.36-.36v-5a2.333,2.333,0,0,0,1.17-1.386l2.718-6.228A.306.306,0,0,0,88.453,4.9Zm11.736,7.578V10.152c0-3.8-2.16-5.688-5.742-5.688a26.993,26.993,0,0,0-3.834.27.544.544,0,0,0-.522.63v11.9a.544.544,0,0,0,.522.63,26.993,26.993,0,0,0,3.834.27C98.029,18.162,100.189,16.272,100.189,12.474Zm-3.078,0c0,2.43-1.044,3.078-2.664,3.078-.45,0-1.026-.018-1.278-.036V7.11c.252-.018.828-.036,1.278-.036,1.62,0,2.664.648,2.664,3.078Z",
    transform: "translate(-2061 2740)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12437",
    "data-name": "Path 12437",
    d: "M977.361,491.935l-25-25h-2.828l25,25-25,25v7h2v-6.172Z",
    transform: "translate(-2842.394 2257.565)",
    fill: "#373f45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4_Byg",
    "data-name": "4 Byg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-fill-4",
    transform: "translate(584.351 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6386-2",
    "data-name": "Rectangle 6386",
    width: 194.126,
    height: 57,
    transform: "translate(-2866.351 2725)",
    fill: "#0f4b98"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-7",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-3654.937 2096.287)",
    fill: "#2c71cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3449.35, 2725)",
    filter: "url(#Path_12436-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-8",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-205.59 -628.71)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "text-4",
    d: "M61.264,14.634V12.978a.361.361,0,0,0-.36-.36H59.716V4.986a.361.361,0,0,0-.36-.36H57.43a.543.543,0,0,0-.468.252L51.274,12.33a.959.959,0,0,0-.2.558v1.746a.361.361,0,0,0,.36.36h5.2V17.64a.346.346,0,0,0,.342.36h2.394a.346.346,0,0,0,.342-.36V14.994H60.9A.361.361,0,0,0,61.264,14.634Zm-4.536-2.016h-2.88c-.072,0-.108-.018-.108-.072a.132.132,0,0,1,.036-.108L56.6,8.586c.018-.018.036-.036.054-.036.036,0,.072.036.072.108ZM77.86,14.13v-.27a2.872,2.872,0,0,0-1.6-2.664A2.849,2.849,0,0,0,77.77,8.55V8.226c0-2.862-2.286-3.762-5.688-3.762a27.841,27.841,0,0,0-3.222.2c-.7.108-.954.36-.954,1.17V16.776c0,.81.27,1.044.99,1.17a22.818,22.818,0,0,0,3.294.216C75.3,18.162,77.86,17.3,77.86,14.13ZM74.8,8.694c0,.774-.414,1.422-1.836,1.422H70.948V7c.252-.018,1.08-.018,1.368-.018,1.854,0,2.484.45,2.484,1.44Zm.072,5.364c0,1.008-.594,1.584-2.448,1.584-.252,0-1.188-.018-1.476-.018V12.258h2.016c1.44,0,1.908.738,1.908,1.6ZM89.236,4.9a.27.27,0,0,0-.288-.27H86.356a.4.4,0,0,0-.36.306l-1.944,5.076c-.09.234-.144.27-.27.27s-.18-.036-.27-.27L81.568,4.932a.4.4,0,0,0-.36-.306H78.616a.27.27,0,0,0-.288.27.306.306,0,0,0,.018.126l2.718,6.228a2.349,2.349,0,0,0,1.188,1.386v5a.361.361,0,0,0,.36.36H84.97a.361.361,0,0,0,.36-.36v-5A2.333,2.333,0,0,0,86.5,11.25l2.718-6.228A.306.306,0,0,0,89.236,4.9Zm9.918,2.16V5.148c0-.162-.126-.234-.306-.27a17.059,17.059,0,0,0-3.762-.414c-2.61,0-5.472,1.152-5.472,5.742v2.232c0,4.554,3.078,5.724,5.13,5.724a19.531,19.531,0,0,0,4.032-.378c.27-.054.36-.162.36-.414V11.322a.361.361,0,0,0-.36-.36h-2.3a.346.346,0,0,0-.342.36v4.14c-.432.036-.882.054-1.386.054-.882,0-2.016-.576-2.016-3.06v-2.25c0-2.358.9-3.06,2.358-3.06,1.53,0,2.88.108,3.744.144h.054C99.046,7.29,99.154,7.254,99.154,7.056Z",
    transform: "translate(-2248 2740)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12437-2",
    "data-name": "Path 12437",
    d: "M977.361,491.935l-25-25h-2.828l25,25-25,25v7h2v-6.172Z",
    transform: "translate(-3037.394 2257.565)",
    fill: "#373f45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3_Byd",
    "data-name": "3 Byd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-fill-3",
    transform: "translate(390.165 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6386-3",
    "data-name": "Rectangle 6386",
    width: 194.126,
    height: 57,
    transform: "translate(-2866.165 2725)",
    fill: "#0f4b98"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-9",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-3654.751 2096.287)",
    fill: "#2c71cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3255.17, 2725)",
    filter: "url(#Path_12436-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-10",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-399.59 -628.71)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "text-3",
    d: "M59.761,14.184V13.86a3,3,0,0,0-1.6-2.7,3.341,3.341,0,0,0,1.6-2.754V8.154c0-2.7-1.764-3.69-4.7-3.69a12.926,12.926,0,0,0-3.672.558c-.18.054-.36.162-.36.342V6.8a.312.312,0,0,0,.324.324h.036a35.294,35.294,0,0,1,3.546-.216c1.4,0,1.782.54,1.782,1.35v.252a1.4,1.4,0,0,1-1.53,1.566h-3.1a.331.331,0,0,0-.342.342v1.53a.346.346,0,0,0,.342.36h3.168c1.17,0,1.458.738,1.458,1.548v.324c0,.99-.5,1.53-1.782,1.53-.972,0-2.322-.054-3.582-.162h-.036a.312.312,0,0,0-.324.324v1.44c0,.18.162.288.342.342a13.505,13.505,0,0,0,3.726.5C57.853,18.162,59.761,16.938,59.761,14.184Zm17.316-.054v-.27a2.872,2.872,0,0,0-1.6-2.664A2.849,2.849,0,0,0,76.987,8.55V8.226c0-2.862-2.286-3.762-5.688-3.762a27.841,27.841,0,0,0-3.222.2c-.7.108-.954.36-.954,1.17V16.776c0,.81.27,1.044.99,1.17a22.818,22.818,0,0,0,3.294.216C74.521,18.162,77.077,17.3,77.077,14.13Zm-3.06-5.436c0,.774-.414,1.422-1.836,1.422H70.165V7c.252-.018,1.08-.018,1.368-.018,1.854,0,2.484.45,2.484,1.44Zm.072,5.364c0,1.008-.594,1.584-2.448,1.584-.252,0-1.188-.018-1.476-.018V12.258h2.016c1.44,0,1.908.738,1.908,1.6ZM88.453,4.9a.27.27,0,0,0-.288-.27H85.573a.4.4,0,0,0-.36.306l-1.944,5.076c-.09.234-.144.27-.27.27s-.18-.036-.27-.27L80.785,4.932a.4.4,0,0,0-.36-.306H77.833a.27.27,0,0,0-.288.27.306.306,0,0,0,.018.126l2.718,6.228a2.349,2.349,0,0,0,1.188,1.386v5a.361.361,0,0,0,.36.36h2.358a.361.361,0,0,0,.36-.36v-5a2.333,2.333,0,0,0,1.17-1.386l2.718-6.228A.306.306,0,0,0,88.453,4.9Zm11.736,7.578V10.152c0-3.8-2.16-5.688-5.742-5.688a26.993,26.993,0,0,0-3.834.27.544.544,0,0,0-.522.63v11.9a.544.544,0,0,0,.522.63,26.993,26.993,0,0,0,3.834.27C98.029,18.162,100.189,16.272,100.189,12.474Zm-3.078,0c0,2.43-1.044,3.078-2.664,3.078-.45,0-1.026-.018-1.278-.036V7.11c.252-.018.828-.036,1.278-.036,1.62,0,2.664.648,2.664,3.078Z",
    transform: "translate(-2442 2740)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12437-3",
    "data-name": "Path 12437",
    d: "M977.361,491.935l-25-25h-2.828l25,25-25,25v7h2v-6.172Z",
    transform: "translate(-3231.394 2257.565)",
    fill: "#373f45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2_Byg",
    "data-name": "2 Byg",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-fill-2",
    transform: "translate(195.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6386-4",
    "data-name": "Rectangle 6386",
    width: 194.126,
    height: 57,
    transform: "translate(-2865.091 2725)",
    fill: "#0f4b98"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-11",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-3653.677 2096.287)",
    fill: "#2c71cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3060.09, 2725)",
    filter: "url(#Path_12436-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12436-12",
    "data-name": "Path 12436",
    d: "M982.711,628.714H788.586v50H982.711l25-25Z",
    transform: "translate(-593.59 -628.71)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "text-2",
    d: "M58.276,7.9c0-2.3-1.278-3.438-4.59-3.438a14.343,14.343,0,0,0-3.834.558c-.18.054-.342.162-.342.342v1.4a.332.332,0,0,0,.324.36h.036c1.1-.108,2.448-.234,3.546-.234,1.458,0,1.908.306,1.908,1.08,0,.846-.27.99-1.836,2.088l-1.656,1.17A5.64,5.64,0,0,0,49.384,15.8V17.64a.361.361,0,0,0,.36.36h8.01a.361.361,0,0,0,.36-.36V15.786a.346.346,0,0,0-.36-.342H52.066v-.072c0-1.26,1.08-2.034,2.61-3.06l1.53-1.026A3.937,3.937,0,0,0,58.276,7.9ZM75.52,14.13v-.27a2.872,2.872,0,0,0-1.6-2.664A2.849,2.849,0,0,0,75.43,8.55V8.226c0-2.862-2.286-3.762-5.688-3.762a27.841,27.841,0,0,0-3.222.2c-.7.108-.954.36-.954,1.17V16.776c0,.81.27,1.044.99,1.17a22.818,22.818,0,0,0,3.294.216C72.964,18.162,75.52,17.3,75.52,14.13ZM72.46,8.694c0,.774-.414,1.422-1.836,1.422H68.608V7c.252-.018,1.08-.018,1.368-.018,1.854,0,2.484.45,2.484,1.44Zm.072,5.364c0,1.008-.594,1.584-2.448,1.584-.252,0-1.188-.018-1.476-.018V12.258h2.016c1.44,0,1.908.738,1.908,1.6ZM86.9,4.9a.27.27,0,0,0-.288-.27H84.016a.4.4,0,0,0-.36.306l-1.944,5.076c-.09.234-.144.27-.27.27s-.18-.036-.27-.27L79.228,4.932a.4.4,0,0,0-.36-.306H76.276a.27.27,0,0,0-.288.27.306.306,0,0,0,.018.126l2.718,6.228a2.349,2.349,0,0,0,1.188,1.386v5a.361.361,0,0,0,.36.36H82.63a.361.361,0,0,0,.36-.36v-5a2.333,2.333,0,0,0,1.17-1.386l2.718-6.228A.306.306,0,0,0,86.9,4.9Zm9.918,2.16V5.148c0-.162-.126-.234-.306-.27a17.059,17.059,0,0,0-3.762-.414c-2.61,0-5.472,1.152-5.472,5.742v2.232c0,4.554,3.078,5.724,5.13,5.724a19.531,19.531,0,0,0,4.032-.378c.27-.054.36-.162.36-.414V11.322a.361.361,0,0,0-.36-.36h-2.3a.346.346,0,0,0-.342.36v4.14c-.432.036-.882.054-1.386.054-.882,0-2.016-.576-2.016-3.06v-2.25c0-2.358.9-3.06,2.358-3.06,1.53,0,2.88.108,3.744.144h.054C96.706,7.29,96.814,7.254,96.814,7.056Z",
    transform: "translate(-2636 2740)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12437-4",
    "data-name": "Path 12437",
    d: "M977.361,491.935l-25-25h-2.828l25,25-25,25v7h2v-6.172Z",
    transform: "translate(-3425.394 2258.065)",
    fill: "#373f45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1_Byd",
    "data-name": "1 Byd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-fill-1",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_991-2",
    "data-name": "Rectangle 991",
    d: "M949.533,523.935H769.276a10,10,0,0,1-10-10v-37a10,10,0,0,1,10-10H949.533Z",
    transform: "translate(-3619.276 2258.065)",
    fill: "#0f4b98"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12434-2",
    "data-name": "Path 12434",
    d: "M949.533,466.935H769.276a10,10,0,0,0-10,10v30a10,10,0,0,0,10,10H949.533l25-25Z",
    transform: "translate(-3619.276 2258.065)",
    fill: "#2c71cb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2865, 2725)",
    filter: "url(#Path_12434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12434-3",
    "data-name": "Path 12434",
    d: "M949.533,466.935H769.276a10,10,0,0,0-10,10v30a10,10,0,0,0,10,10H949.533l25-25Z",
    transform: "translate(-754.28 -466.93)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "text-1",
    d: "M49.411,15.444a.346.346,0,0,0-.36.342V17.64a.361.361,0,0,0,.36.36h7.848a.361.361,0,0,0,.36-.36V15.786a.346.346,0,0,0-.36-.342H54.865V4.968a.331.331,0,0,0-.342-.342H52.9a.949.949,0,0,0-.414.072l-3.258,1.53a.248.248,0,0,0-.18.252V8.532c0,.144.072.234.2.234a.622.622,0,0,0,.216-.054L51.805,7.7v7.74ZM74.737,14.13v-.27a2.872,2.872,0,0,0-1.6-2.664A2.849,2.849,0,0,0,74.647,8.55V8.226c0-2.862-2.286-3.762-5.688-3.762a27.841,27.841,0,0,0-3.222.2c-.7.108-.954.36-.954,1.17V16.776c0,.81.27,1.044.99,1.17a22.818,22.818,0,0,0,3.294.216C72.181,18.162,74.737,17.3,74.737,14.13Zm-3.06-5.436c0,.774-.414,1.422-1.836,1.422H67.825V7c.252-.018,1.08-.018,1.368-.018,1.854,0,2.484.45,2.484,1.44Zm.072,5.364c0,1.008-.594,1.584-2.448,1.584-.252,0-1.188-.018-1.476-.018V12.258h2.016c1.44,0,1.908.738,1.908,1.6ZM86.113,4.9a.27.27,0,0,0-.288-.27H83.233a.4.4,0,0,0-.36.306l-1.944,5.076c-.09.234-.144.27-.27.27s-.18-.036-.27-.27L78.445,4.932a.4.4,0,0,0-.36-.306H75.493a.27.27,0,0,0-.288.27.306.306,0,0,0,.018.126l2.718,6.228a2.349,2.349,0,0,0,1.188,1.386v5a.361.361,0,0,0,.36.36h2.358a.361.361,0,0,0,.36-.36v-5a2.333,2.333,0,0,0,1.17-1.386L86.1,5.022A.306.306,0,0,0,86.113,4.9Zm11.736,7.578V10.152c0-3.8-2.16-5.688-5.742-5.688a26.993,26.993,0,0,0-3.834.27.544.544,0,0,0-.522.63v11.9a.544.544,0,0,0,.522.63,26.993,26.993,0,0,0,3.834.27C95.689,18.162,97.849,16.272,97.849,12.474Zm-3.078,0c0,2.43-1.044,3.078-2.664,3.078-.45,0-1.026-.018-1.278-.036V7.11c.252-.018.828-.036,1.278-.036,1.62,0,2.664.648,2.664,3.078Z",
    transform: "translate(-2829 2740)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12435",
    "data-name": "Path 12435",
    d: "M977.361,491.935l-25-25h-2.828l25,25-25,25v7h2v-6.172Z",
    transform: "translate(-3619.276 2257.565)",
    fill: "#373f45"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBar);
export default __webpack_public_path__ + "static/media/progress-bar.f2f39118.svg";
export { ForwardRef as ReactComponent };